import axios from 'axios'

import {
  defaultRequestErrorInterceptor,
  defaultResponseSuccessInterceptor,
  integrationResponseErrorInterceptor,
  publicResponseErrorInterceptor,
  requestCookieTokenInterceptor,
  requestTokenFromUrlInterceptor,
  responseErrorInterceptor,
} from './interceptors'

const axiosAPI = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosAPI.interceptors.response.use(defaultResponseSuccessInterceptor, responseErrorInterceptor)

const authAPI = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

authAPI.interceptors.response.use(defaultResponseSuccessInterceptor, responseErrorInterceptor)
authAPI.interceptors.request.use(requestCookieTokenInterceptor, defaultRequestErrorInterceptor)

const visitorParkingAPI = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

visitorParkingAPI.interceptors.response.use(
  defaultResponseSuccessInterceptor,
  publicResponseErrorInterceptor,
)
visitorParkingAPI.interceptors.request.use(
  requestTokenFromUrlInterceptor,
  defaultRequestErrorInterceptor,
)

const integrationAPI = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

integrationAPI.interceptors.response.use(
  defaultResponseSuccessInterceptor,
  integrationResponseErrorInterceptor,
)
integrationAPI.interceptors.request.use(
  requestCookieTokenInterceptor,
  defaultRequestErrorInterceptor,
)

const marketShopAPI = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

marketShopAPI.interceptors.response.use(
  defaultResponseSuccessInterceptor,
  publicResponseErrorInterceptor,
)
marketShopAPI.interceptors.request.use(
  requestTokenFromUrlInterceptor,
  defaultRequestErrorInterceptor,
)

export { authAPI, axiosAPI, integrationAPI, marketShopAPI, visitorParkingAPI }
